module.exports = __webpack_public_path__ + "static/bg1-e251a437d4fb451ed4dcb7df84175095.png";